import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';

import {
  DynamicSchemaDefinitionField,
  DynamicSchemaDefinitionMultiLineText,
  DynamicSchemaDefinitionPositiveInteger,
  DynamicSchemaDefinitionSelectMultiple,
  DynamicSchemaDefinitionSingleLineText,
} from '../../../../../generated/graphql';
import { SPACING_UNIT } from '../../../../constant/spacing';
import { gridLayoutItem } from '../../../../styleUtility/gridLayout';

type Props = {
  field: DynamicSchemaDefinitionField;
  labelPaddingTop: number;
  className?: string;
};

const hasIsRequired = (
  field: DynamicSchemaDefinitionField,
): field is Extract<
  DynamicSchemaDefinitionField,
  DynamicSchemaDefinitionMultiLineText | DynamicSchemaDefinitionPositiveInteger | DynamicSchemaDefinitionSingleLineText
> => Object.hasOwnProperty.call(field, 'isRequired');

const hasIsRequiredToSelectAnything = (
  field: DynamicSchemaDefinitionField,
): field is DynamicSchemaDefinitionSelectMultiple => Object.hasOwnProperty.call(field, 'isRequiredToSelectAnything');

const Base: FC<Props> = ({ field, labelPaddingTop, className, children }) => {
  const getLabel = (field: DynamicSchemaDefinitionField): string => {
    let label = field.label;

    if (hasIsRequired(field) && field.isRequired) {
      label = `${field.label} *`;
    }

    if (hasIsRequiredToSelectAnything(field) && field.isRequiredToSelectAnything) {
      label = `${field.label} *`;
    }

    return label;
  };

  return (
    <div className={className}>
      <Label variant="subtitle1" paddingTop={labelPaddingTop}>
        {getLabel(field)}
      </Label>
      <Input>{children}</Input>
    </div>
  );
};

const Label = styled(Typography)<{ paddingTop: number }>`
  margin-bottom: ${SPACING_UNIT}px;
  padding-top: ${(props) => props.paddingTop}px;
  word-wrap: break-word;
`;

const Input = styled.div`
  ${gridLayoutItem('input')}
  width: 100%;
`;

export default Base;
